import { render, staticRenderFns } from "./vsCheckbox.vue?vue&type=template&id=033af1d8&lang=html"
import script from "./vsCheckbox.vue?vue&type=script&lang=js"
export * from "./vsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports